import { useEffect, useState } from 'react';
import { X, Search, User, Loader } from 'lucide-react';
import { CallAPIGetPromise, CallAPIPostPromise } from 'Common/commaon';
import { toast } from 'sonner';
import { getDecodeId } from 'slices/userProfile/thunk';

interface Contractor {
  id: string;
  name: string;
  email: string;
  phone: string;
  rating: number;
  specialties: string[];
}

const normalizeSearchValue = (value: unknown) =>
  String(value ?? '').toLowerCase();

const MOCK_CONTRACTORS: Contractor[] = [
  {
    id: '1',
    name: 'Emmeline Labrie',
    email: 'emmeline.labrie@example.com',
    phone: '(555) 123-4567',
    rating: 4.8,
    specialties: ['Plumbing', 'HVAC'],
  },
  {
    id: '2',
    name: 'Zac Wight',
    email: 'zac.wight@example.com',
    phone: '(555) 234-5678',
    rating: 4.9,
    specialties: ['Electrical', 'Solar'],
  },
  {
    id: '3',
    name: 'Poppy Nicholls',
    email: 'poppy.nicholls@example.com',
    phone: '(555) 345-6789',
    rating: 4.7,
    specialties: ['Roofing', 'Gutters'],
  },
  {
    id: '4',
    name: 'Da-Xia Wu',
    email: 'da-xia.wu@example.com',
    phone: '(555) 456-7890',
    rating: 4.9,
    specialties: ['General Contractor', 'Remodeling'],
  },
  {
    id: '5',
    name: 'Marisa Palermo',
    email: 'marisa.palermo@example.com',
    phone: '(555) 567-8901',
    rating: 4.6,
    specialties: ['Painting', 'Drywall'],
  },
];

interface AssignContractorModalProps {
  leadId: string;
  isOpen: boolean;
  onClose: () => void;
  onAssign: (leadId: string, contractorId: string) => void;
}

export function AssignContractorModal({ leadId, isOpen, onClose, onAssign, }: AssignContractorModalProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedContractor, setSelectedContractor] = useState<string | null>(null);
  const [contrctrsa,setContrctrs]=useState([])
  const [laoding,setLoading]=useState(false)
  useEffect(()=>{
   
    CallAPIGetPromise("/admin//v2/get-all-contractors/contractor").then((res:any)=>{
      console.log(res)
      if(res?.data){
        setContrctrs(Array.isArray(res.data.data) ? res.data.data : [])
      }
    })
     },[])
  if (!isOpen) return null;

  const normalizedSearchTerm = normalizeSearchValue(searchTerm).trim();
  const filteredContractors = contrctrsa.filter((contractor:any) =>
    contractor &&
      [
        contractor.user_first_name,
        contractor.user_last_name,
        contractor.user_email,
        contractor.user_phone,
      ].some((value) =>
        normalizeSearchValue(value).includes(normalizedSearchTerm),
      )
  );

  const handleAssign = (id:any) => {
    if (id) {
      setSelectedContractor(id)
      setLoading(true)
      CallAPIPostPromise("/jobs/sendContractorRequestForJob",{
        contractor_ids:  [id],
        job_id:leadId,
        admin_id:getDecodeId()
      }).then(()=>{
        setSearchTerm('');
        onClose();
  toast.success("Lead reqest sent")

      onAssign(leadId, id);

      }).finally(()=>{
        setLoading(false)
      })
     
    }
  };
  return (
    <div style={{
      zIndex:9999
    }} className="fixed inset-0  flex items-center justify-center bg-black/50 bg-opacity-70">
      <div className="bg-[#2C2D31] rounded-xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden m-4">
        {/* Header */}
        <div className="bg-[#2C2D31] border-b border-solid border-l-0 border-t-0 border-r-0 border-gray-700 px-6 py-4 flex items-center justify-between">
          <div>
            <div className="text-xl font-semibold text-white">Assign Contractor</div>
            <div className="text-sm text-gray-400 mt-1">Invite and manage your team members.</div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-700 bg-transparent border-0 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-400" />
          </button>
        </div>

        {/* Search */}
        <div className="px-6 py-4 bg-[#2C2D31]">
          <div className="relative flex gap-3">
            <input
              type="text"
              style={{
                border:"1px solid #374151"
              }}
              placeholder="Search by email,phone,name "
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="flex-1 px-4 py-2.5 text-sm bg-[#1C1D21] text-white placeholder-gray-500  rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <button className="px-6 py-2.5 text-sm font-medium border-0 text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors">
              Search
            </button>
          </div>
        </div>

        {/* Contractors List */}
        <div className="overflow-y-auto max-h-[400px] px-6 py-2">
          <div className="space-y-0">
            {filteredContractors.length === 0 ? (
              <div className="text-center py-12 text-gray-400">
                <User className="w-12 h-12 mx-auto mb-2 text-gray-600" />
                <p>No contractors found</p>
              </div>
            ) : (
              filteredContractors.map((contractor:any) => (
                <div
                  key={contractor.id}
                  onClick={() => setSelectedContractor(contractor.id)}
                  className={`py-3 cursor-pointer transition-all border-b border-solid border-l-0 border-r-0 border-t-0 border-gray-700 hover:bg-[#35363B] ${
                    selectedContractor === contractor.id
                      ? 'bg-[#35363B]'
                      : ''
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3 flex-1">
                      <div className="w-10 h-10 rounded-lg overflow-hidden bg-gray-700 flex items-center justify-center">
                        <span className="text-sm font-medium text-gray-300">
                          {String(contractor?.user_first_name ?? 'C').charAt(0)}
                        </span>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2">
                          <h3 className="font-medium text-blue-400 text-sm">
                          {[contractor?.user_first_name, contractor?.user_last_name]
                            .filter(Boolean)
                            .join(' ') || 'Contractor'}

                          </h3>
                        </div>
                        <div className="text-sm text-gray-400 mt-0.5">{contractor?.user_email || 'No email available'}</div>
                      </div>
                    </div>
                    <button
  onClick={(e) => {
    e.stopPropagation(); // row click se selection disturb na ho
    // 
    handleAssign(contractor.id)
    // yaha tu assign api call bhi kar sakta hai
    // handleAssign(contractor.id);
  }}
  className={`px-4 py-2 text-xs font-medium border-0 rounded-lg transition-colors bg-[#1C1D21] text-gray-300 hover:bg-[#2A2B30]
  `}
  style={{
    border: "1px solid #374151",
  }}
>
 {laoding && selectedContractor === contractor.id ?<Loader  size={15}/>:""}  {"Assign"}
</button>

                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
